"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toNotationPictoListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toNotationPictoListSlice = function (data, logger) {
    var _a;
    var title = logger.required(fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.title));
    var notations_picto = data.items
        .map(function (item) { return toNotationPictoItem(item, logger); })
        .filter(Boolean);
    // Test liste notations non vide
    if (!title || !(notations_picto === null || notations_picto === void 0 ? void 0 : notations_picto.length)) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.NotationPictoList)), { title: title,
        notations_picto: notations_picto }));
};
exports.toNotationPictoListSlice = toNotationPictoListSlice;
var toNotationPictoItem = function (data, logger) {
    var image = logger.required(fields_1.toImage(data.image, logger));
    // Test des champs obligatoires
    if (!image) {
        return undefined;
    }
    return utils_1.compact({
        image: image,
        notation_title: fields_1.toText(data.notationTitle),
        description: fields_1.toText(data.description),
        cta: field_groups_1.toCta(data, logger)
    });
};
//# sourceMappingURL=notation-picto-list-slice.js.map